<template>
  <v-app>
    <v-main>
      <router-view/>
      <!-- <HomeView></HomeView> -->
       <means></means>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',
  data: () => ({
    
  }),


};
</script>